<script setup lang="ts">
import {Label} from "@/core/components/ui/label";
import {pluralize} from "@/core/filters/Pluralize";

const enabled = defineModel<boolean>("enabled", {required: true});
defineProps<{
    count: number
}>();
</script>

<template>
  <div class="flex items-center gap-2 border-l border-gray-300 pl-2">
    <Label for="toggleShowHidden" class="text-xs" :class="{ 'opacity-50': !enabled}">
      {{ count }} {{ pluralize('programme masqué', count) }},
      <span class="text-decoration-underline cursor-pointer" @click="enabled = ! enabled">
        <span v-if="!enabled">voir</span>
        <span v-else>masquer</span>
      </span>
    </Label>
  </div>
</template>
